module.exports = __webpack_public_path__ + "img/guide.1775439203884.png";